import Highcharts from 'highcharts';
import HighchartsReact from 'highcharts-react-official';

import type { JobResult } from '@/api/fe-api/domain/entities/capacity-evaluation';

import { getThroughputChartConfig } from './get-throughput-chart-config';

export type ThroughputChartLayoutProps = {
  labels: [string, string];
  results: JobResult[];
};

export function SectionThroughputCharts({
  labels,
  results,
}: ThroughputChartLayoutProps) {
  function getBinnedData(key: 'chargingSohC' | 'dischargingSohC') {
    const bins = Array.from({ length: 13 }, (_, i) => 0.6 + i * 0.05);

    let binnedData = bins.slice(0, -1).map((binStart, index) => {
      const binEnd = bins[index + 1];

      return {
        name: `${(binStart * 100).toFixed(0)}–${(binEnd * 100).toFixed(0)}%`,
        y: results.filter((item) =>
          index === bins.length - 2
            ? item[key] >= binStart && item[key] <= binEnd
            : item[key] >= binStart && item[key] < binEnd,
        ).length,
      };
    });

    // If there's only one column, add empty columns on either side
    if (binnedData.length === 1) {
      const singleColumn = binnedData[0];
      const emptyColumn = { name: '', y: 0 };
      binnedData = [emptyColumn, singleColumn, emptyColumn];
    }

    return binnedData;
  }

  return (
    <div className="flex gap-8">
      <div className="flex-1">
        <HighchartsReact
          highcharts={Highcharts}
          options={getThroughputChartConfig({
            data: getBinnedData('chargingSohC'),
            title: 'Charge',
            levelLabels: labels,
          })}
        />
      </div>
      <div className="flex-1">
        <HighchartsReact
          highcharts={Highcharts}
          options={getThroughputChartConfig({
            data: getBinnedData('dischargingSohC'),
            title: 'Discharge',
            levelLabels: labels,
          })}
        />
      </div>
    </div>
  );
}
